/**
 * TanStack Query hooks for `igaming-native-integrations-with-softswiss-pragmat`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingNativeIntegrationsWithSoftswissPragmatQueryKeys,
	type CreateIgamingNativeIntegrationsWithSoftswissPragmatBody,
	type ListIgamingNativeIntegrationsWithSoftswissPragmatResponse,
	type IgamingNativeIntegrationsWithSoftswissPragmatRow,
} from "./api";

export function useIgamingNativeIntegrationsWithSoftswissPragmatList(): UseQueryResult<ListIgamingNativeIntegrationsWithSoftswissPragmatResponse, Error> {
	return useQuery({
		queryKey: igamingNativeIntegrationsWithSoftswissPragmatQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingNativeIntegrationsWithSoftswissPragmatCreate(): UseMutationResult<IgamingNativeIntegrationsWithSoftswissPragmatRow, Error, CreateIgamingNativeIntegrationsWithSoftswissPragmatBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNativeIntegrationsWithSoftswissPragmatQueryKeys.all });
		},
	});
}

export function useIgamingNativeIntegrationsWithSoftswissPragmatDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingNativeIntegrationsWithSoftswissPragmatQueryKeys.all });
		},
	});
}
